import runtimeConfig from '@/app/configs/runtime-config';
import { isDev } from '@/shared/config';
import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: runtimeConfig.SENTRY_DSN,
  enabled: !isDev && runtimeConfig.SENTRY_DSN,
  environment: runtimeConfig.ENVIROPMENT,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  replaysOnErrorSampleRate: 1,
  replaysSessionSampleRate: 0.1,
  tracesSampleRate: 1,
});
